import * as angular from 'angular';
import {
    LeadTimeDto,
    LeadTimeRule,
    LeadTimeRuntimeTimeUnitLabel,
    LeadTimeSettings,
    LeadTimeTimeUnitLabel,
    RegularFcfsService
} from 'app/_services/regularFcfsService';

class NetworkPointDetailsOperatorInfoFcfsLeadTimesComponentCtrl
    implements ng.IController
{
    networkPoint: NetworkPointDto;
    private leadTimeSettings: LeadTimeSettings;

    leadTimesExpanded: boolean = true;
    uiLoadingLeadTimes: boolean = true;

    constructor(private regularFcfsService: RegularFcfsService) {}

    $onInit(): void {
        this.loadExistingLeadTimes();
    }

    private loadExistingLeadTimes(): void {
        this.regularFcfsService
            .networkPointLeadTimeSettings(this.networkPoint.networkPointUuid)
            .then((leadTimeSettings) => {
                this.leadTimeSettings = leadTimeSettings;
                this.uiLoadingLeadTimes = false;
            });
    }

    getContractPeriodString(leadTimeRule: LeadTimeRule) {
        if (leadTimeRule.contractPeriodType === 'SUBSEQUENT_WITHINDAY') {
            return '< 1 day';
        } else if (leadTimeRule.contractPeriodType === 'FULL_WITHINDAY') {
            return '1 day';
        } else {
            return leadTimeRule.infiniteRuntime
                ? 'Open end rule'
                : `< ${leadTimeRule.runtimeLength.value} ${LeadTimeRuntimeTimeUnitLabel[leadTimeRule.runtimeLength.timeUnit]}`;
        }
    }

    getLeadTimeString(leadTime: LeadTimeDto) {
        if (leadTime.leadTimeUnit === 'AT_ANY_TIME') return 'at any time';
        return `${leadTime.value} ${LeadTimeTimeUnitLabel[leadTime.leadTimeUnit]}`;
    }

    get leadTimeRulesEnabled() {
        return this.leadTimeSettings
            ? this.leadTimeSettings.leadTimeRulesEnabled
            : false;
    }

    get leadTimeRules() {
        return this.leadTimeSettings ? this.leadTimeSettings.leadTimeRules : [];
    }
}

angular
    .module('app')
    .component('pkpNetworkPointDetailsOperatorInfoFcfsLeadTimes', {
        controller: NetworkPointDetailsOperatorInfoFcfsLeadTimesComponentCtrl,
        template:
            require('app/network-point/network-point-details-operator-info-fcfs-lead-times.component.html'),
        bindings: {
            networkPoint: '='
        }
    });
